import createReactComponent from '../createReactComponent';
export default createReactComponent('mood-xd', 'IconMoodXd', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z', key: 'svg-1' }],
  ['path', { d: 'M9 14h6a3 3 0 1 1 -6 0z', key: 'svg-2' }],
  ['path', { d: 'M9 8l6 3', key: 'svg-3' }],
  ['path', { d: 'M9 11l6 -3', key: 'svg-4' }],
]);
